import React, { useEffect, useState } from "react"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js"
import { Bar } from "react-chartjs-2"

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

const options = {
  responsive: true,
  maintainAspectRatio: false,
  plugins: {
    legend: {
      position: "bottom",
    },
  },
}

const BarChart = () => {
  const token = localStorage.getItem('authToken');
  const [chartData, setChartData] = useState({
    labels: [],
    datasets: [
      {
        label: "Earning Analytics",
        backgroundColor: "#02a499",
        borderColor: "#02a499",
        borderWidth: 1,
        hoverBackgroundColor: "#02a499",
        hoverBorderColor: "#02a499",
        data: [],
      },
    ],
  })

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch("https://api.kunalsdrumclass.com/api/GetDailySales", {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })

        const json = await res.json()
        const rows = json.recordsets[0]

        const labels = rows.map(r => r.payment_date)
        const data = rows.map(r => Number(r.total_payment))

        setChartData({
          labels,
          datasets: [
            {
              label: "Earning Analytics",
              backgroundColor: "#02a499",
              borderColor: "#02a499",
              borderWidth: 1,
              hoverBackgroundColor: "#02a499",
              hoverBorderColor: "#02a499",
              data,
            },
          ],
        })
      } catch (error) {
        console.error("Error fetching chart data:", error)
      }
    }

    fetchData()
  }, [])

  return <Bar width={600} height={245} options={options} data={chartData} />
}

export default BarChart